export enum ProductType {
  Residential = 'residential',
  Commercial = 'commercial'
}
